import React from 'react';
import EDIOrdersImport from './containers/EDIOrdersImport';

// Load test functions for development
if (process.env.NODE_ENV === 'development') {
    import('./utilities/testPricingConsole.js').catch(console.error);
    import('./utilities/quickPricingTest.js').catch(console.error);
}

/**
 * Application which imports order from EDI .txt file to .csv file.
 *
 * @returns {JSX.Element}
 * @constructor
 */
const App = () => <EDIOrdersImport />;

export default App;
